import { useInfiniteQuery } from '@tanstack/react-query';
import { favoriteMarketService } from 'shared/src/api';
import { queryKey } from '../../../constant/queryKey';

export const useFavoriteMarkets = () => {
  return useInfiniteQuery({
    queryKey: queryKey.favoriteMarkets(),
    queryFn: ({ pageParam }: { pageParam?: string }) =>
      favoriteMarketService.getFavoriteMarkets({ next_token: pageParam }),
    initialPageParam: undefined,
    getNextPageParam: lastPage => lastPage.next_token ?? undefined,
    // 화면 unmount 시 캐시 즉시 제거 → 재진입 때 찜 해제된 마켓이 안 보이도록 fresh fetch
    gcTime: 0,
    select: data => ({
      list_id: data.pages[data.pages.length - 1]?.list_id ?? '',
      total_count: data.pages[data.pages.length - 1]?.total_count ?? 0,
      markets: data.pages.flatMap(page => page.markets),
    }),
  });
};
